var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[((_vm.position.x || _vm.position.y) && _vm.nowData.length)?_c('div',{class:_vm.getClass},_vm._l((_vm.nowData),function(item,index){return _c('div',{key:index,staticClass:"list_item",on:{"click":function($event){return _vm.handleClick(item)}}},[_c('div',{staticClass:"item_name"},[_vm._v(_vm._s(item.name))])])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }